/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const FactoryAuditTypes = {
  // GET
  GET_ITEM_LIST: asyncActionType('GET_ITEM_LIST'),
  GET_ITEM_DETAIL: asyncActionType('GET_ITEM_DETAIL'),
  GET_QUOTE_LIST_ITEM_DETAIL: asyncActionType('GET_QUOTE_LIST_ITEM_DETAIL'),
  GET_QUOTE_ITEM_DETAIL: asyncActionType('GET_QUOTE_ITEM_DETAIL'),
  GET_REPORT_ITEM_DETAIL: asyncActionType('GET_REPORT_ITEM_DETAIL'),
  GET_INVOICE_ITEM_DETAIL: asyncActionType('GET_INVOICE_ITEM_DETAIL'),
  GET_INVOICE_LIST_ITEM_DETAIL: asyncActionType('GET_INVOICE_LIST_ITEM_DETAIL'),
  GET_SERVICE_PROVIDER_LIST: asyncActionType('GET_SERVICE_PROVIDER_LIST'),

  // CREATE
  CREATE_ITEM: asyncActionType('CREATE_ITEM'),
  CREATE_QUOTE_ITEM_DETAIL: asyncActionType('CREATE_QUOTE_ITEM_DETAIL'),
  CREATE_REPORT_ITEM_DETAIL: asyncActionType('CREATE_REPORT_ITEM_DETAIL'),
  CREATE_INVOICE_ITEM_DETAIL: asyncActionType('CREATE_INVOICE_ITEM_DETAIL'),

  // UPDATE
  UPDATE_ITEM_DETAIL: asyncActionType('UPDATE_ITEM_DETAIL'),
  UPDATE_JOB_STATUS: asyncActionType('UPDATE_JOB_STATUS'),
  UPDATE_QUOTE_ITEM_DETAIL: asyncActionType('UPDATE_QUOTE_ITEM_DETAIL'),
  UPDATE_REPORT_ITEM_DETAIL: asyncActionType('UPDATE_REPORT_ITEM_DETAIL'),
  UPDATE_INVOICE_ITEM_DETAIL: asyncActionType('UPDATE_INVOICE_ITEM_DETAIL'),

  // DELETE
  DELETE_INVOICE_ITEM_DETAIL: asyncActionType('DELETE_INVOICE_ITEM_DETAIL'),

  // DOWNLOAD
  DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL: asyncActionType('DOWNLOAD_QUOTE_ATTACHMENT_ITEM_DETAIL'),
  DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL: asyncActionType('DOWNLOAD_REPORT_ATTACHMENT_ITEM_DETAIL'),
  DOWNLOAD_FACTORY_AUDIT: asyncActionType('DOWNLOAD_FACTORY_AUDIT'),
  DOWNLOAD_INVOICE_LIST_ITEM_DETAIL: asyncActionType('DOWNLOAD_INVOICE_LIST_ITEM_DETAIL'),

  // PAYER
  GET_PAYER_LIST: asyncActionType('GET_PAYER_LIST'),
  CREATE_PAYER: asyncActionType('CREATE_PAYER'),
};
